(function($) {
	'use strict';
	$.fn.InfiniteScroll = function() {
		this.each(function() {

			/*
			 * Action: Accordion open / close
			 */
			var $self = $(this),
				allow_scroll = true,
				args = { page: 2 };

			// If we have a search term, add it to our ajax args
			if( $self.data('s') !== undefined && $self.data('s').length > 0 ) {
				args.s = $self.data('s');
			}

			// Add load more button to our grid-items container
			$self.append( '<span class="load-more"></span>' );
			var $loader = $self.find('.load-more');

			// On Scroll
			$.Window.on('scroll.infinite-scroll', function(){

				if( allow_scroll ) {

					allow_scroll = false;
					setTimeout( function() {

						var offset = $loader.offset().top - $.Window.scrollTop();
						if( offset < 2000 ) { // <= if 2000 from the bottom

							// Turn on loading graphic
							$loader.addClass('on');

							// Get our data
							$.Globals.ajax( 'scspaces_infinite_scroll', args, function( response ) {

								// We have data, so show it
								if( response.success ) {

									// Append the data
									$self.append( response.data.html );

									// init contorllers
									$('[data-controller]').not('.instantiated').Instantiate();

									// Move the loader the bottom
									$self.append( $loader );
									args.page = args.page + 1;
									allow_scroll = true;

								} else {

									// No more data, so remove loader and stop listening for scroll
									$loader.remove();
									$.Window.off('scroll.infinite-scroll');
									return false;

								}
							});

						} else {

							// We are not low enough on the page, so allow it to run again
							allow_scroll = true;

						}

					}, 100 );

				}
			});

		});
		return this;
	};
}(jQuery));
